$(document).ready(function(){
  
  $('ul.tabs').each(function(){
    var active, content, links = $(this).find('a');
    active = links.first().addClass('active');
    content = $(active.attr('href'));
    links.not(':first').each(function () {
      $($(this).attr('href')).hide();
    });
    $(this).find('a').click(function(e){
      active.removeClass('active');
      $(this).parent('li').addClass('active');
      $(this).parent('li').siblings().removeClass('active');
      content.hide();
      active = $(this);
      content = $($(this).attr('href'));
      active.addClass('active');
      content.show();
      return false;
    });
  });
  
  $('.dev_registerPage .dev_register a').trigger('click');
  
});
function onSelectGender(gender, evt)
{
  var query = $("#query").val();
  
  var pre_value = $("#gender").val(); 
  if(pre_value == "")
  {
    if(query == ""){
      $("#gender").val(gender);
  	  $(evt.target).addClass("current-active");    	
    }
    else{
      $("#gender").val(gender);
      $(evt.target).addClass("current-active");
      $("#searchFormSubmit").submit();
    }
  	
  }
  
  if(pre_value == gender)
  {
    if(query == "")
    {
      //$("#gender").val("");
  	  //$(evt.target).removeClass("current-active");
    	
    }
    else{
      //$("#gender").val("");
  	  //$(evt.target).removeClass("current-active");
      $("#searchFormSubmit").submit();
    
    }
  	
  }
  if(pre_value != "" && pre_value != gender)
  {
  	
    if(pre_value == "1")
    {
      if(query == "")
      {
      	$("#male").removeClass("current-active");
      	$("#gender").val(gender);
      	$("#female").addClass("current-active");
      }
      else
      {
        $("#male").removeClass("current-active");
      	$("#gender").val(gender);
      	$("#female").addClass("current-active");
        $("#searchFormSubmit").submit();
      
      }
      
      
    }
    if(pre_value == "0")
    {
      if(query == "")
      {
      	$("#female").removeClass("current-active");
      	$("#gender").val(gender);
      	$("#male").addClass("current-active");
      }
      else
      {
        $("#female").removeClass("current-active");
      	$("#gender").val(gender);
      	$("#male").addClass("current-active");
        $("#searchFormSubmit").submit();
      
      }
      
    	
    }
  }
  
  //e.preventDefault();
  
  
}
$(document).ready(function(){
  var locations = location.search;
  console.log(locations);
  
  if(locations != ""){
    
    if(locations.includes("gender") == true){
      var paramsArray = locations.split('gender=');

      var queryParams = paramsArray[1];
      if(queryParams == "0")
      {
        $("#gender").val(queryParams);
        $("#female").addClass("current-active");
        $("#genders").val(queryParams);
        $("#females").addClass("current-active");

      }

      if(queryParams == "1")
      {
        $("#gender").val(queryParams);
        $("#male").addClass("current-active");
        $("#genders").val(queryParams);
        $("#males").addClass("current-active");

      }
    }
    else
    {
      $("#male").addClass("current-active");
      $("#males").addClass("current-active");
      $("#genders").val(1);
      $("#gender").val(1);
    	
    }
  }
  else
  {
    $("#male").addClass("current-active");
    $("#males").addClass("current-active");
    $("#genders").val(1);
    $("#gender").val(1);
    
  }
  
});
function onSelectGenders(gender, evt)
{
 
  var query = $("#querys").val();
  
  var pre_value = $("#genders").val(); 
  if(pre_value == "")
  {
    if(query == ""){
      $("#genders").val(gender);
  	  $(evt.target).addClass("current-active");    	
    }
    else{
      $("#genders").val(gender);
      $(evt.target).addClass("current-active");
      $("#searchFormSubmits").submit();
    }
  	
  }
  
  if(pre_value == gender)
  {
    if(query == "")
    {
      //$("#genders").val("");
  	  //$(evt.target).removeClass("current-active");
    	
    }
    else{
      //$("#genders").val("");
  	  //$(evt.target).removeClass("current-active");
      $("#searchFormSubmits").submit();
    
    }
  	
  }
  if(pre_value != "" && pre_value != gender)
  {
  	
    if(pre_value == "1")
    {
      if(query == "")
      {
      	$("#males").removeClass("current-active");
      	$("#genders").val(gender);
      	$("#females").addClass("current-active");
      }
      else
      {
        $("#males").removeClass("current-active");
      	$("#genders").val(gender);
      	$("#females").addClass("current-active");
        $("#searchFormSubmits").submit();
      
      }
      
      
    }
    if(pre_value == "0")
    {
      if(query == "")
      {
      	$("#females").removeClass("current-active");
      	$("#genders").val(gender);
      	$("#males").addClass("current-active");
      }
      else
      {
        $("#females").removeClass("current-active");
      	$("#genders").val(gender);
      	$("#males").addClass("current-active");
        $("#searchFormSubmits").submit();
      
      }
      
    	
    }
  }
  
  //e.preventDefault();
  
  
}